/* global Excel */

/**
 * Reads article codes from the specified column and row range in the active worksheet.
 * Returns an array of { row, code } pairs for non-empty cells.
 */
export async function readArticleCodes(
  startRow: number,
  endRow: number,
  column: string
): Promise<{ row: number; code: string }[]> {
  const results: { row: number; code: string }[] = [];

  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getActiveWorksheet();
      const rangeAddress = `${column}${startRow}:${column}${endRow}`;
      const range = sheet.getRange(rangeAddress);
      range.load("values");
      await context.sync();

      for (let i = 0; i < range.values.length; i++) {
        const value = range.values[i][0];
        if (value !== null && value !== undefined && String(value).trim() !== "") {
          results.push({ row: startRow + i, code: String(value).trim() });
        }
      }
    });
  } catch (err) {
    const message = err instanceof Error ? err.message : String(err);
    throw new Error(`Failed to read article codes from Excel (${column}${startRow}:${column}${endRow}): ${message}`);
  }

  return results;
}
